import { render, staticRenderFns } from "./KitchenDisplay.vue?vue&type=template&id=af977d3c"
import script from "./KitchenDisplay.vue?vue&type=script&lang=js"
export * from "./KitchenDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports